var AppComponent = /** @class */ (function () {
    function AppComponent() {
        this.title = 'Admin Dashboard Web App';
    }
    return AppComponent;
}());
export { AppComponent };
